<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc">
<h1 class="SOM_titre" epub:type="title">Contents</h1>
<div class="SOM_pre"><a href="#/pre2">G<span class="small">ETTING</span> <span class="small">THE</span> M<span class="small">OST</span> O<span class="small">UT</span> <span class="small">OF</span> <i>S<span class="small">PIRITUAL</span> W<span class="small">ARFARE</span></i></a></div>
<div class="SOM_chap"><a href="#/chap1"><b>1   Detecting the Deceiver</b><span class="tabulation">2 Corinthians 11:1-15</span></a></div>
<div class="SOM_chap"><span href="#/chap2" title="Link target outside of Sample"><b>2   Facing Temptation</b><span class="tabulation">Matthew 4:1-11</span></span></div>
<div class="SOM_chap"><span href="#/chap3" title="Link target outside of Sample"><b>3   The Serpent’s Strategy</b><span class="tabulation">Genesis 3:1-6</span></span></div>
<div class="SOM_chap"><span href="#/chap4" title="Link target outside of Sample"><b>4   The Armor of God</b><span class="tabulation">Ephesians 6:10-20</span></span></div>
<div class="SOM_chap"><span href="#/chap5" title="Link target outside of Sample"><b>5   The War Within</b><span class="tabulation">James 4:1-10</span></span></div>
<div class="SOM_chap"><span href="#/chap6" title="Link target outside of Sample"><b>6   Defeating the Destroyer</b><span class="tabulation">Mark 5:1-20</span></span></div>
<div class="SOM_chap"><span href="#/chap7" title="Link target outside of Sample"><b>7   Overcoming Our Accuser</b><span class="tabulation">Revelation 12:7-12</span></span></div>
<div class="SOM_chap"><span href="#/chap8" title="Link target outside of Sample"><b>8   Surviving Satan’s Attacks</b><span class="tabulation">Job 1—2</span></span></div>
<div class="SOM_chap"><span href="#/chap9" title="Link target outside of Sample"><b>9   Standing Firm</b><span class="tabulation">2 Thessalonians 2:1-17</span></span></div>
<div class="SOM_appen"><span href="#/appen3" title="Link target outside of Sample">Leader’s Notes</span></div>
<div class="SOM_appen"><span href="#/appen5" title="Link target outside of Sample">About the Contributor</span></div>
<div class="SOM_appen"><span href="#/moreIVP" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
<div class="SOM_pdf"><span href="#/ident11#copy1" title="Link target outside of Sample">Copyright</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?1881b241